import { Component, Input } from '@angular/core';
import { HygraphImage, PlatformImage } from '@app/@shared/services/hygraph/hygraph.models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToolbarTypes } from '../../generic-toolbar/toolbar-type';
import { ImageViewerToolsConfiguration } from '../../image-viewer/image-viewer.component';
import { FeatureFlagService, ffKeys } from '@app/@shared/services/featureflag.service';

@Component({
    selector: 'app-image-modal',
    templateUrl: './image-modal.component.html',
    styleUrls: ['./image-modal.component.scss'],
    standalone: false
})
export class ImageModalComponent {
  @Input() image: HygraphImage | PlatformImage;

  toolbarType = ToolbarTypes.HTML_IMAGE_VIEWER;
  toolsConfiguration: ImageViewerToolsConfiguration = {
    closeViewer: true,
    zoomIn: true,
    zoomOut: true,
    fitToPage: true,
    toggleImageResolution: false,
  };
  enableHGEmbeddedImageViewer$ = this.featureFlagService.getFlag(ffKeys.enableHGEmbeddedImageViewer);

  constructor(
    public activeModal: NgbActiveModal,
    public featureFlagService: FeatureFlagService
  ) {}
}
